import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err, "Errore di accesso"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <Link to="/" data-testid="admin-login-logo"><img src="/logo.png" alt="Funghetto Roma" className="h-10 w-auto mx-auto" /></Link>
          <p className="text-[10px] uppercase tracking-[0.35em] text-[#555] mt-2">Area riservata</p>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="border border-[#E5E5E5] bg-white p-8 space-y-5">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-[#555] mb-2" htmlFor="adm-email">Email</label>
            <Input id="adm-email" data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   className="rounded-none h-11" autoComplete="username" />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-[#555] mb-2" htmlFor="adm-pass">Password</label>
            <Input id="adm-pass" data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                   className="rounded-none h-11" autoComplete="current-password" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-[#6B1E33]">{error}</p>}
          <button type="submit" data-testid="admin-login-submit" disabled={loading}
                  className="w-full text-xs uppercase tracking-[0.3em] bg-[#0A0A0A] text-[#FAF9F6] py-4 hover:bg-[#6B1E33] transition-colors duration-300 disabled:opacity-50">
            {loading ? "…" : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
